
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="text-center mt-5 pb-4 text-white">
      <div className="social-icons d-flex justify-content-center gap-4 mb-3">
        <a
          href="https://www.instagram.com/infoservice.barreiras"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white fs-4"
        >
          <i className="bi bi-instagram"></i>
        </a>
        <a
          href="https://wa.me/5577998485717?text=Olá!%20Gostaria%20de%20mais%20informações."
          target="_blank"
          rel="noopener noreferrer"
          className="text-white fs-4"
        >
          <i className="bi bi-whatsapp"></i>
        </a>
      </div>

      <p className="mb-1" style={{ fontSize: '0.95rem' }}>
        <i className="bi bi-geo-alt-fill me-2 text-white"></i>
        <Link to="/contato" className="text-white text-decoration-none">
          R. Ernesto Geisel, 85 - Ouro Branco, Barreiras - BA
        </Link>
      </p>

      <p style={{ fontSize: '0.8rem', marginTop: '20px', opacity: 0.7 }}>
        &copy; {new Date().getFullYear()} InfoService Barreiras. Todos os direitos reservados.
      </p>
    </footer>
  );
}

export default Footer;
